import {Pipe, PipeTransform} from '@angular/core';
import * as moment from 'moment';

@Pipe({
    name: 'tel'
})
export class TelPipe implements PipeTransform {

    transform(value: any): string {
        if (value) {
            return value.replace(/(\d)(?=(\d{2})+$)/g, '$1 ');
        } else {
            return '-';
        }
    }

}



// WEBPACK FOOTER //
// ./src/shared/pipes/tel.pipe.ts